export const CONSULTATION_CLINIC_ID = '30456428';
